package hk.com.vr360_demo2.webapp.component.viewer.component


import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.img
import web.cssom.AlignItems
import web.cssom.Cursor
import web.cssom.Display
import web.cssom.FlexDirection
import web.cssom.NamedColor
import web.cssom.TextAlign
import web.cssom.px
import kotlin.js.js
import kotlin.js.unsafeCast

external interface PhoneButtonProps : Props {
    var mobile: String?
    /** 全景數據中的 `title`（物業標題/地址描述），用於 WhatsApp 預填文案 */
    var propertyTitle: String?
    /** 接口 `PanoramaDataJsonResult.version`，`1` 為公司版 */
    var version: Int?
    /** URL 參數 `uid`，公司版有 uid 時跳轉 WhatsApp */
    var uid: String?
}

val PhoneButton = FC<PhoneButtonProps> { props ->
    val isCompanyWithoutUid = props.version == 1 && props.uid.isNullOrBlank()
    val iconSrc = if (isCompanyWithoutUid) {
        "/assets/images/phone.svg"
    } else {
        "/assets/images/whatapps.svg"
    }
    val iconAlt = if (isCompanyWithoutUid) "電話" else "WhatsApp"

    div {
        css {
            display = Display.flex
            flexDirection = FlexDirection.column
            alignItems = AlignItems.center
            cursor = Cursor.pointer

            color = NamedColor.white
            gap = 4.px
        }
        onClick = {
            val match = Regex("(\\d{8})").find(props.mobile ?: "")
            if (match != null) {
                val phone = "852" + match.value
                if (isCompanyWithoutUid) {
                    kotlinx.browser.window.location.href = "tel:+$phone"
                } else {
                    val currentUrl = kotlinx.browser.window.location.href
                    val title = props.propertyTitle?.trim().orEmpty()
                    val addressText = if (title.isNotEmpty()) title else currentUrl
                    val message = "你好，我想查詢 $addressText $currentUrl"
                    val encodedMessage = js("encodeURIComponent")(message) as String
                    val url = "https://api.whatsapp.com/send/?phone=$phone&text=$encodedMessage"
                    kotlinx.browser.window.open(url, "_blank")
                }
            }
        }
        img {
            src = iconSrc
            alt = iconAlt
            css {
                width = 24.px
                height = 24.px
            }
        }
        div {
            css {
                fontSize = 14.px
                minWidth = 64.px
                textAlign= TextAlign.center
                // 小屏幕下隱藏文字
                asDynamic()["@media (max-width: 600px)"] = js("{}").unsafeCast<react.CSSProperties>().apply {
                    display = "none".unsafeCast<Display>()
                }
            }
            +(props.mobile ?: "")
        }
    }
}
